/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Button as MuiButton } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import { Helmet } from "react-helmet";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import ExportButton from "../../Components/ExportButton/ExportButton";
import EmptyFileIcon from "../../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../../components/common/Loader/Loader";
import Modal from "../../../../components/common/Modal/Modal";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  DROPDOWN_KEYS,
  Constants,
  AlertStatus,
  DROPDOWN_REDUX_KEY_MAPPER,
  OS_DROPDOWN_KEYS,
} from "../../../../contants";
import useParamsQuery from "../../../../hooks/useParamsQuery";
import { selectOSKeysByUserRole } from "../../../../redux/selectors/user";
import Reports from "../../../../services/api/reports";
import {
  formDataToObject,
  isEmptyObj,
  isOSKey,
} from "../../../../utils/helper";
import styles from "../../FriendsReports/FriendSearch.styles";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import InputField from "../../../../components/common/new/InputField/InputField";
import OrganizationSearchWrapper from "../../AttendanceReports/StructureLevelAttendanceReport/OrganizationSearchAttendance";
import ReportTable from "./ReportTable";

const LOADER_DELAY = 1000;
const PAGE = "page";

const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

const OS_FILTER_KEYS = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

const getRoutePath = () => "/reports/appointment/transfer-leader-not-appointed";

const initialFormValue = {
  from: "",
  to: "",
};

const CLUSTER_FLOW_CUTOFF_DATE = new Date("2026-04-01T00:00:00");

const isClusterFlowByDateFrom = (dateFromValue) => {
  if (!dateFromValue) return false;
  const d = new Date(dateFromValue);
  if (Number.isNaN(d.getTime())) return false;
  return d.getTime() >= CLUSTER_FLOW_CUTOFF_DATE.getTime();
};

function TransferLeaderNotAppointedReport() {
  const TITLE = "Transfer Leader Not Appointed - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const allowModalRef = useRef(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const toast = useContext(ToastAlertContext);

  const [dateFrom, setDateFrom] = useState(initialFormValue.from);
  const [dateTo, setDateTo] = useState(initialFormValue.to);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
    setDateFrom("");
    setDateTo("");
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (
          key === "clusterId" &&
          !isClusterFlowByDateFrom(queryObject?.from)
        ) {
          return;
        }
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const handleFromDateChange = (newValue) => {
    const fromValue = newValue
      ? moment(new Date(newValue)).format("YYYY-MM-DD")
      : "";

    let toValue = dateTo;
    if (fromValue && toValue && moment(toValue).isBefore(moment(fromValue))) {
      toValue = fromValue;
    }

    if (fromValue && toValue) {
      const diffDays = moment(toValue).diff(moment(fromValue), "days");
      if (diffDays > 365) {
        toValue = moment(fromValue).add(365, "days").format("YYYY-MM-DD");
      }
    }

    setDateFrom(fromValue);
    setDateTo(toValue);
  };

  const handleToDateChange = (newValue) => {
    const toValue = newValue
      ? moment(new Date(newValue)).format("YYYY-MM-DD")
      : "";

    let fromValue = dateFrom;
    if (fromValue && toValue && moment(toValue).isBefore(moment(fromValue))) {
      fromValue = toValue;
    }

    if (fromValue && toValue) {
      const diffDays = moment(toValue).diff(moment(fromValue), "days");
      if (diffDays > 365) {
        fromValue = moment(toValue).subtract(365, "days").format("YYYY-MM-DD");
      }
    }

    setDateFrom(fromValue);
    setDateTo(toValue);
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    const updatedQuery = {
      ...queryObject,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
    clearFormRef();
  };

  const validateAndFetchData = (formattedQuery, toastCtx, setLoading) => {
    if (
      !formattedQuery.hasOwnProperty("areaId") ||
      formattedQuery.areaId === ""
    ) {
      toastCtx.show("Please enter Area", AlertStatus.ERROR);
      setLoading(false);
      return false;
    }

    if (
      !formattedQuery.hasOwnProperty("from") ||
      formattedQuery.from === "" ||
      !formattedQuery.hasOwnProperty("to") ||
      formattedQuery.to === ""
    ) {
      toastCtx.show("Please select From and To date", AlertStatus.ERROR);
      setLoading(false);
      return false;
    }

    return true;
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["pageNumber", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const fetchSearchData = async (queryParams) => {
    try {
      setIsLoading(true);

      if (validateAndFetchData(queryParams, toast, setIsLoading)) {
        const response = await Reports.transferLeaderNotAppointedReport(
          queryParams
        );
        const { data } = response;

        setSearchData(Array.isArray(data) ? data : []);

        setTimeout(() => {
          setIsLoading(false);
          if (Array.isArray(data) && data.length > 0) {
            if (allowModalRef.current) {
              setOpenResultModal(true);
              setShowSearchResult(true);
              allowModalRef.current = false;
            }
          } else {
            toast.show("No data found.", AlertStatus.ERROR);
            setOpenResultModal(false);
            setShowSearchResult(false);
            allowModalRef.current = false;
          }
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      setOpenResultModal(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    if (dateFrom !== "") {
      formData.from = dateFrom;
    }
    if (dateTo !== "") {
      formData.to = dateTo;
    }

    if (!isClusterFlowByDateFrom(formData?.from)) {
      delete formData.clusterId;
      if (formRef.current?.clusterId) {
        formRef.current.clusterId.value = "";
      }
    }

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );

    if (!hasFilter) {
      toast.show("Please select your search filter", AlertStatus.ERROR);
      return;
    }

    const query = queryString.stringify(formData);
    document.dispatchEvent(new Event(EVENT_NAME));

    allowModalRef.current = true;
    updateSearchParam(query);
    fetchSearchData(formData);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject) && hasAnyRealFilter(queryObject)) {
      const query = getQueryParams(queryObject)[0];

      const safeMetaData = metaData ?? {};
      const safeOrgStructure = safeMetaData?.organisationStructure ?? {};
      const safeDisabledOSKeys = Array.isArray(disabledOSKeys)
        ? disabledOSKeys
        : [];

      const resolveDropdownValue = (filterKey, value) => {
        const pool = isOSKey(filterKey)
          ? safeOrgStructure[DROPDOWN_REDUX_KEY_MAPPER[filterKey]]
          : safeMetaData[DROPDOWN_REDUX_KEY_MAPPER[filterKey]];

        if (!Array.isArray(pool)) {
          return value;
        }

        const selectedValue = pool.find(
          (p) =>
            (p.structureId || p.divisionId || p.cityId || p.stateId) ===
            Number(value)
        );

        return (
          selectedValue?.shortName ||
          selectedValue?.name ||
          selectedValue?.cityName ||
          selectedValue?.stateName ||
          value
        );
      };

      const dateFilter = query?.from
        ? [
            {
              key: "from",
              displayName: "Period",
              value: `${moment(query.from).format("DD-MMM-YYYY")} - ${moment(
                query.to
              ).format("DD-MMM-YYYY")}`,
              disabled: safeDisabledOSKeys.includes("from"),
            },
          ]
        : [];

      const orderedFilters = filterOrder
        .map((filterKey) => {
          const value = query?.[filterKey];
          if (value === undefined || String(value).trim() === "") {
            return null;
          }

          const isDropdown =
            DROPDOWN_KEYS.includes(filterKey) ||
            OS_DROPDOWN_KEYS.includes(filterKey);

          return {
            key: filterKey,
            displayName: AppliedFilterLabelMap[filterKey] || filterKey,
            value: isDropdown ? resolveDropdownValue(filterKey, value) : value,
            disabled: safeDisabledOSKeys.includes(filterKey),
          };
        })
        .filter(Boolean);

      setAppliedFilters([...dateFilter, ...orderedFilters]);
    } else {
      setAppliedFilters([]);
    }
  }, [urlSearchParams.toString()]);

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    setShowSearchResult(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setShowSearchResult(false);
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "flex-end",
                flexWrap: isMobile ? "wrap" : "nowrap",
              }}
            >
              <div style={{ width: isMobile ? "97%" : "25%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From"
                    name="from"
                    // format="DD/MM/YYYY"
                    inputFormat="DD/MM/YYYY"
                    value={dateFrom ? dayjs(dateFrom) : null}
                    disableFuture
                    onChange={handleFromDateChange}
                    renderInput={(props) => <InputField {...props} />}
                  />
                </LocalizationProvider>
              </div>

              <div style={{ width: isMobile ? "97%" : "25%" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="To"
                    name="to"
                    // format="DD/MM/YYYY"
                    inputFormat="DD/MM/YYYY"
                    value={dateTo ? dayjs(dateTo) : null}
                    disableFuture
                    onChange={handleToDateChange}
                    renderInput={(props) => <InputField {...props} />}
                  />
                </LocalizationProvider>
              </div>
            </div>

            {dateFrom && dateTo && (
              <div>
                <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                  Organization Structure
                </div>

                <OrganizationSearchWrapper
                  key={`${moment(dateFrom).format("YYYY-MM-DD")}`}
                  disabledOSKeys={disabledOSKeys}
                  selectedDate={dateFrom}
                />
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>

        {isLoading && <Loader />}

        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {appliedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <ExportButton
                    data={searchData}
                    // eslint-disable-next-line prettier/prettier
                    exportFunction={
                      Reports.downloadTransferLeaderNotAppointedReport
                    }
                  />
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <ReportTable searchData={searchData} />
              </div>
            </>
          ) : showSearchResult ? null : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "30px 0",
                color: "#777",
              }}
            >
              <EmptyFileIcon width={100} />
              <span>No data found with current Filters</span>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
}

export default TransferLeaderNotAppointedReport;
